const FEATURE_IMAGE_MAP = {
  "core financial management": {
    "general ledger": "general-ledger.png",
    "financial-statements": "financial-statement-designer.png",
    "taxes": "taxes.png",
    "budgets": "budgets.png",
    "fixed-assets": "fixed-assets.png",
  },
  "transaction & inventory management": {
    "inventory": "inventory.png",
    "purchases": "purchases.png",
    "sales": "sales.png",
    "payables": "payables.png",
    "receivables": "receivables.png",
  },
  "reporting features": {
    "dashboards-analytics": "dashboards-and-analytics.png",
    "customizable-reporting": "report-designer.png",
    "financial-clarifications": "financial-clarifications.png",
    "print-designer": "print-designer.png",
  },
  "control features": {
    "document-center": "document-center.png",
    "audit-trail": "audit-trail-and-records-history.png",
    "backup-scheduling": "backup-scheduling.png",
    "permissions": "permissions.png",
    "digital-storage": "degital-storage.png",
    "automated-notifications": "automated-notifications.png",
    "email-invoice-sending": "email-invoice-sending.png",
  },
};

export default FEATURE_IMAGE_MAP;
